var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none",class:{ active: _vm.type === 'white' }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('div',{staticClass:"image-empty-item"},[_c('img',{attrs:{"src":require("../../assets/home/training-empty.png"),"alt":""}}),_c('span',[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }